import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { fetchWarehouseDetail } from '../../actions/warehouses_actions';
import { searchZones, selectZone, resetCurrentZone, deleteZone } from '../../actions/zones_actions';
import { fetchWarehouseBins } from '../../actions/warehouses_actions';
import { getBinsByZone, getLevelsByBin, generateZoneBarcode, createZone, editZone, deleteBinsBD, generateBin, deleteBin, selectBin, 
selectLevel, editBins, editLevels, attachZoneBinLevel, importZoneBinLevel, createLevelFailure, createBinFailure, createZoneFailure } from "../../actions/zones_actions";

import WarehouseDetail from '../../components/Inventories/warehouseDetail';

let warehouseDetail = reduxForm({
    form: 'warehouseDetail'
})(WarehouseDetail);

const selector = formValueSelector('warehouseDetail')

function mapStateToProps(state) {
    const nameValue = selector(state, 'ZoneName');
    return {
        nameValue,
        zones: state.zones.all,
        warehouseBinsDetail: state.warehouses.warehouseBinsDetail,
        currentWarehouse: state.warehouses.currentWarehouse,
        currentWarehouseDetail: state.warehouses.currentWarehouseDetail,
        detailIsLoading: state.warehouses.detailIsLoading,
        detailError: state.warehouses.detailError,
        deleteZone: state.zones.deleteZone,
        deleteZoneSuccess: state.zones.deleteZoneSuccess,
        deleteZoneFailureError: state.zones.deleteZoneFailureError,
        deleteBin: state.zones.deleteBin,
        deleteBinSuccess: state.zones.deleteBinSuccess,
        deleteBinFailureError: state.zones.deleteBinFailureError,
        deleteLevel: state.zones.deleteLevel,
        deleteLevelSuccess: state.zones.deleteLevelSuccess,
        deleteLevelFailureError: state.zones.deleteLevelFailure,
        createBinSuccess: state.zones.createBinSuccess,
        createLevelSuccess: state.zones.createLevelSuccess,
        levelCreateError: state.zones.levelCreateError,
        binCreateError: state.zones.binCreateError,
        createError: state.zones.createError,
        bins: state.zones.bins,
        levels: state.zones.levels,
        attachDocumentSuccess: state.zones.attachDocumentSuccess,
        updatedLevel: state.zones.updatedLevel,
        updatedBin: state.zones.updatedBin,
    }
}

export default connect(mapStateToProps, { 
    generateBin, 
    deleteBinsBD, 
    editZone, 
    createZone, 
    generateZoneBarcode, 
    getLevelsByBin, 
    getBinsByZone, 
    fetchWarehouseBins, 
    fetchWarehouseDetail, 
    searchZones, 
    selectZone, 
    resetCurrentZone, 
    deleteBin,
    deleteZone, 
    selectBin,
    selectLevel,
    editLevels,
    editBins,
    attachZoneBinLevel,
    importZoneBinLevel,
    createLevelFailure, 
    createBinFailure, 
    createZoneFailure})(warehouseDetail)



// WEBPACK FOOTER //
// ./master/jsx/containers/Inventories/warehouseDetail.jsx